import { getAssignedExperimentBuckets } from '../configs/experiments.manager'

// This should be deprecated and cleaned up all over the codebase as they lead to hydration issues
// They can be used in util functions but we have to carefully use this and lack of knowledge could
// lead to uses of these functions within components.
// https://lastbrand.atlassian.net/browse/SFPLTFRM-760
export const getAssignedExperimentBucket = (experimentName: string): string => {
  const assignedExperimentBucketConfigForUser = getAssignedExperimentBuckets()
  return assignedExperimentBucketConfigForUser[experimentName]?.bucket ?? ''
}

export const isAssignedExperimentBucket = (experimentName: string, bucketName: string): boolean => {
  const assignedExperimentBucketConfigForUser = getAssignedExperimentBuckets()
  return assignedExperimentBucketConfigForUser[experimentName]
    ? assignedExperimentBucketConfigForUser[experimentName].bucket === bucketName
    : false
}
